<template>
    <section class="team-wrapper">
        <span class="a-t-s1">Kierownictwo CSS</span>
        <div class="cards">
            <ul>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">
                        <div style="height:400px;width:374px;background-size: cover;background-position: center;background-image: url('https://imgs.search.brave.com/y5k1BL4PLr0jDWK15sQFqO9hsaSiU-MqI3rTXnPyV14/rs:fit:500:500:1/g:ce/aHR0cDovL3NoYWNr/bWFubGFiLm9yZy93/cC1jb250ZW50L3Vw/bG9hZHMvMjAxMy8w/Ny9wZXJzb24tcGxh/Y2Vob2xkZXIuanBn');">
                        </div>
                        <span class="a-t-s2">Robert Bąk</span>
                        <v-divider></v-divider>
                        <span class="a-t-s3">CEO</span>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">
                        <div
                            style="height:400px;width:374px;background-size: cover;background-position: center;background-image: url('https://imgs.search.brave.com/y5k1BL4PLr0jDWK15sQFqO9hsaSiU-MqI3rTXnPyV14/rs:fit:500:500:1/g:ce/aHR0cDovL3NoYWNr/bWFubGFiLm9yZy93/cC1jb250ZW50L3Vw/bG9hZHMvMjAxMy8w/Ny9wZXJzb24tcGxh/Y2Vob2xkZXIuanBn');">
                        </div>
                        <span class="a-t-s2">Robert Bąk</span>
                        <v-divider></v-divider>
                        <span class="a-t-s3">CEO</span>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">
                        <div
                            style="height:400px;width:374px;background-size: cover;background-position: center;background-image: url('https://imgs.search.brave.com/y5k1BL4PLr0jDWK15sQFqO9hsaSiU-MqI3rTXnPyV14/rs:fit:500:500:1/g:ce/aHR0cDovL3NoYWNr/bWFubGFiLm9yZy93/cC1jb250ZW50L3Vw/bG9hZHMvMjAxMy8w/Ny9wZXJzb24tcGxh/Y2Vob2xkZXIuanBn');">
                        </div>
                        <span class="a-t-s2">Robert Bąk</span>
                        <v-divider></v-divider>
                        <span class="a-t-s3">CEO</span>
                    </v-card>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'about-team'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.team-wrapper {
    margin: 0 0 50px 0;
    .a-t-s1 {
        font-size: 34px;
    }
    .cards {
        margin: 20px 0 0 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        @include mobileBig {
            margin: 0;
        }

        ul {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 0;
            padding: 0;

            li {
                margin: 0 30px;
                list-style-type: none;
                @include mobileBig {
                    margin: 0 10px;
                }
                .a-t-s2 {
                    font-size: 28px;
                    line-height: 60px;
                }
                .a-t-s3 {
                    font-size: 20px;
                    line-height: 40px;
                }
            }
        }
    }
}
</style>